// extracted by mini-css-extract-plugin
export default {"question":"X_cM","titleLabel":"X_cV","prosCons":"X_cW","pros":"X_cX","cons":"X_cY"};